import { SetupAffiliateAccountRequestBody } from "@syla/shared/types/requests/SetupAffiliateAccount";
import axios from "axios";

export const setupAffiliateAccount = async (
  body: SetupAffiliateAccountRequestBody
): Promise<any> => {
  const { data } = await axios.post("/users/setup-affiliate-account", body);
  return data;
};
